import React, { useContext, useRef, useState } from "react";

import { ShotContext } from "../context/index";
import { isValidMultiple, FILE_SIZE_LABEL } from "../../form-inputs/imageUploader/lib/fileHelper";

const MultiFileUpload = () => {
    const fileInputRef = useRef();
    const [isUploading, setIsUploading] = useState(false);
    const { uploadImages } = useContext(ShotContext);

    const openFilePicker = (e) => {
        fileInputRef.current.click();
    };

    const onFileChange = (e) => {
        let { files } = fileInputRef.current;
        setIsUploading(true);
        const validFiles = isValidMultiple(files);

        if (validFiles.length) {
            uploadImages(validFiles);
        }

        /* I'm using this.state.isUploading to create a new file uploader to clear upload files after a file is added */
        setTimeout(() => {
            setIsUploading(false);
        }, 200);
    };

    const file = isUploading ? "" : <input type="file" onChange={onFileChange} accept=".jpg,.jpeg,.png" ref={fileInputRef} multiple={true}></input>;

    return (
        <div>
            <button className="button -full" onClick={openFilePicker}>
                Bulk Image Upload
            </button>
            <div className="hide">{file}</div>
            <small>File size must be less than {FILE_SIZE_LABEL}</small>
        </div>
    );
};

export default MultiFileUpload;
